import type { ProducedOutputItem } from "../types/producedOutput.types";
import type { ProduceOutputApiItem } from "../types/producedOutput.types";

const parseProductionDate = (value: string): string | null => {
  if (!value || value === "-") return null;

  const slashParts = value.split("/").map((part) => part.trim());
  if (slashParts.length === 3) {
    const [day, month, year] = slashParts;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  return value;
};

const parseNumericValue = (value: string): number | null => {
  if (!value.trim()) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const mapApiStatus = (
  status: ProduceOutputApiItem["status"],
): ProducedOutputItem["status"] => (status === "pending" ? "awaiting" : "completed");

export const mapApiProduceOutputToItem = (
  item: ProduceOutputApiItem,
): ProducedOutputItem => {
  const status = mapApiStatus(item.status);
  const variancePercentage = item.variance?.variance_percentage ?? 0;
  const varianceQty = item.variance?.variance_qty;
  const outputUom = item.output_uom?.short_name ?? "";

  return {
    id: String(item.id),
    batchNumber: item.batch_id,
    outputName: item.output_name ?? "—",
    outputSku: item.output_sku ?? "—",
    status,
    actualYield: item.actual_yield?.actual_qty ?? null,
    yieldPercent: item.actual_yield?.actual_yield ?? null,
    variance:
      status === "completed" && item.variance
        ? {
            type: variancePercentage === 0 ? "none" : "preparation_loss",
            weight: varianceQty != null ? Number(varianceQty) : undefined,
            unit: outputUom || undefined,
            percent: variancePercentage,
          }
        : null,
    totalProductionCost: Number(item.total_production_cost) || 0,
    actualCostPerUom: parseNumericValue(item.actual_cost),
    outputUom,
    productionDate: parseProductionDate(item.production_date),
  };
};
